if (!customElements.get('lip-balm-personality')) {
  customElements.define(
    'lip-balm-personality',
    class LipBalmPersonality extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productUrl = this.dataset.productUrl;
        if (!this.sectionId || !this.productUrl) return;

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variantId = event?.data?.variant?.id;
          if (!variantId) return;
          this.refreshForVariant(variantId);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      refreshForVariant(variantId) {
        fetch(`${this.productUrl}?variant=${variantId}&section_id=${this.sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const source = html.getElementById(`LipBalmPersonalityContent-${this.sectionId}`);
            const destination = this.querySelector(`#LipBalmPersonalityContent-${this.sectionId}`);
            if (!source || !destination) return;
            destination.innerHTML = source.innerHTML;
          })
          .catch((error) => console.error(error));
      }
    }
  );
}

